// =========================================================================
// IMPORTS DOS STICKERS (Aproveitando as miniaturas dos presentes de futebol)
// =========================================================================

// Grupo 1
import imgSticker90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import imgStickerAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import imgStickerApito from './assets/presentes/miniaturas/gift_apito.webp';
import imgStickerBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import imgStickerBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';

// Grupo 2
import imgStickerBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import imgStickerBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import imgStickerBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import imgStickerBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import imgStickerBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';

// Grupo 3
import imgStickerBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import imgStickerBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import imgStickerCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import imgStickerCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import imgStickerCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';

// Grupo 4
import imgStickerCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import imgStickerCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import imgStickerCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import imgStickerCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import imgStickerChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';

// Grupo 5
import imgStickerChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import imgStickerChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import imgStickerCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import imgStickerFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import imgStickerFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';

// Grupo 6
import imgStickerFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import imgStickerGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import imgStickerHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import imgStickerHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import imgStickerHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';

// Grupo 7
import imgStickerLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import imgStickerLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import imgStickerLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import imgStickerMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import imgStickerMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';

// Grupo 8
import imgStickerMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import imgStickerMeias from './assets/presentes/miniaturas/gift_meias.webp';
import imgStickerMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import imgStickerMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import imgStickerPlacard from './assets/presentes/miniaturas/gift_placard.webp';

// Grupo 9
import imgStickerRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import imgStickerSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import imgStickerSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import imgStickerTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import imgStickerTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';

// Grupo 10
import imgStickerTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import imgStickerTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import imgStickerTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import imgStickerVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import imgStickerVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';

const CROMOS_REAIS_INICIAIS = [
  // Patamar 100 Moedas
  { cromoNumero: 1, id: 101, nome: '90 Minutos', preco: 100, icone: imgSticker90Minutos, videoUrl: "" },
  { cromoNumero: 2, id: 102, nome: 'Anel de Campeão', preco: 100, icone: imgStickerAnelCampeao, videoUrl: "" },
  { cromoNumero: 3, id: 103, nome: 'Apito', preco: 100, icone: imgStickerApito, videoUrl: "" },
  { cromoNumero: 4, id: 104, nome: 'Baliza', preco: 100, icone: imgStickerBaliza, videoUrl: "" },
  { cromoNumero: 5, id: 105, nome: 'Bancada VIP', preco: 100, icone: imgStickerBancadaVip, videoUrl: "" },
  { cromoNumero: 6, id: 106, nome: 'Banco de Suplentes', preco: 100, icone: imgStickerBancoSuplentes, videoUrl: "" },
  { cromoNumero: 7, id: 107, nome: 'Bandeira da Claque', preco: 100, icone: imgStickerBandeiraClaque, videoUrl: "" },
  { cromoNumero: 8, id: 108, nome: 'Bandeirola de Canto', preco: 100, icone: imgStickerBandeirolaCanto, videoUrl: "" },
  { cromoNumero: 9, id: 109, nome: 'Bola de Ouro', preco: 100, icone: imgStickerBolaOuro, videoUrl: "" },
  { cromoNumero: 10, id: 110, nome: 'Bola em Chamas', preco: 100, icone: imgStickerBolaChamas, videoUrl: "" },

  // Patamar 150 Moedas
  { cromoNumero: 11, id: 111, nome: 'Bota de Diamante', preco: 150, icone: imgStickerBotaDiamante, videoUrl: "" },
  { cromoNumero: 12, id: 112, nome: 'Brasão', preco: 150, icone: imgStickerBrasao, videoUrl: "" },
  { cromoNumero: 13, id: 113, nome: 'Cachecol', preco: 150, icone: imgStickerCachecol, videoUrl: "" },
  { cromoNumero: 14, id: 114, nome: 'Caneleiras', preco: 150, icone: imgStickerCaneleiras, videoUrl: "" },
  { cromoNumero: 15, id: 115, nome: 'Canhão de Camisolas', preco: 150, icone: imgStickerCanhaoCamisolas, videoUrl: "" },
  { cromoNumero: 16, id: 116, nome: 'Canhão de Confetes', preco: 150, icone: imgStickerCanhaoConfetes, videoUrl: "" },
  { cromoNumero: 17, id: 117, nome: 'Capitão', preco: 150, icone: imgStickerCapitao, videoUrl: "" },
  { cromoNumero: 18, id: 118, nome: 'Cartão Amarelo', preco: 150, icone: imgStickerCartaoAmarelo, videoUrl: "" },
  { cromoNumero: 19, id: 119, nome: 'Cartão Vermelho', preco: 150, icone: imgStickerCartaoVermelho, videoUrl: "" },
  { cromoNumero: 20, id: 120, nome: 'Chapéu de Guarda-Redes', preco: 150, icone: imgStickerChapeuGuardaRedes, videoUrl: "" },

  // Patamar 250 Moedas
  { cromoNumero: 21, id: 121, nome: 'Chuteira', preco: 250, icone: imgStickerChuteira, videoUrl: "" },
  { cromoNumero: 22, id: 122, nome: 'Chuteiras em Chamas', preco: 250, icone: imgStickerChuteirasChamas, videoUrl: "" },
  { cromoNumero: 23, id: 123, nome: 'Cronómetro', preco: 250, icone: imgStickerCronometro, videoUrl: "" },
  { cromoNumero: 24, id: 124, nome: 'Fiscal de Linha', preco: 250, icone: imgStickerFiscalLinha, videoUrl: "" },
  { cromoNumero: 25, id: 125, nome: 'Fitas da Claque', preco: 250, icone: imgStickerFitasClaque, videoUrl: "" },
  { cromoNumero: 26, id: 126, nome: 'Fumo da Claque', preco: 250, icone: imgStickerFumoClaque, videoUrl: "" },
  { cromoNumero: 27, id: 127, nome: 'Gorro do Adepto', preco: 250, icone: imgStickerGorroAdepto, videoUrl: "" },
  { cromoNumero: 28, id: 128, nome: 'Hall de Entrada', preco: 250, icone: imgStickerHallEntrada, videoUrl: "" },
  { cromoNumero: 29, id: 129, nome: 'Hat-Trick', preco: 250, icone: imgStickerHatTrick, videoUrl: "" },
  { cromoNumero: 30, id: 130, nome: 'Holofotes', preco: 250, icone: imgStickerHolofotes, videoUrl: "" },

  // Patamar 400 Moedas
  { cromoNumero: 31, id: 131, nome: 'Luva de Espuma', preco: 400, icone: imgStickerLuvaEspuma, videoUrl: "" },
  { cromoNumero: 32, id: 132, nome: 'Luva de Platina', preco: 400, icone: imgStickerLuvaPlatina, videoUrl: "" },
  { cromoNumero: 33, id: 133, nome: 'Luvas de Guarda-Redes', preco: 400, icone: imgStickerLuvasGuardaRedes, videoUrl: "" },
  { cromoNumero: 34, id: 134, nome: 'Medalha de Campeão', preco: 400, icone: imgStickerMedalhaCampeao, videoUrl: "" },
  { cromoNumero: 35, id: 135, nome: 'Medalha de Vice-Campeão', preco: 400, icone: imgStickerMedalhaViceCampeao, videoUrl: "" },
  { cromoNumero: 36, id: 136, nome: 'Megafone', preco: 400, icone: imgStickerMegafone, videoUrl: "" },
  { cromoNumero: 37, id: 137, nome: 'Meias', preco: 400, icone: imgStickerMeias, videoUrl: "" },
  { cromoNumero: 38, id: 138, nome: 'Melhor Treinador', preco: 400, icone: imgStickerMelhorTreinador, videoUrl: "" },
  { cromoNumero: 39, id: 139, nome: 'Moeda ao Ar', preco: 400, icone: imgStickerMoedaAoAr, videoUrl: "" },
  { cromoNumero: 40, id: 140, nome: 'Placard', preco: 400, icone: imgStickerPlacard, videoUrl: "" },

  // Patamar 600 Moedas
  { cromoNumero: 41, id: 141, nome: 'Relvado', preco: 600, icone: imgStickerRelvado, videoUrl: "" },
  { cromoNumero: 42, id: 142, nome: 'Spray de Barreira', preco: 600, icone: imgStickerSprayBarreira, videoUrl: "" },
  { cromoNumero: 43, id: 143, nome: 'Substituição', preco: 600, icone: imgStickerSubstituicao, videoUrl: "" },
  { cromoNumero: 44, id: 144, nome: 'Taça Suprema', preco: 600, icone: imgStickerTacaSuprema, videoUrl: "" },
  { cromoNumero: 45, id: 145, nome: 'Tambor da Claque', preco: 600, icone: imgStickerTamborClaque, videoUrl: "" },
  { cromoNumero: 46, id: 146, nome: 'Torres do Estádio', preco: 600, icone: imgStickerTorresEstadio, videoUrl: "" },
  { cromoNumero: 47, id: 147, nome: 'Troféu de Campeão', preco: 600, icone: imgStickerTrofeuCampeao, videoUrl: "" },
  { cromoNumero: 48, id: 148, nome: 'Troféu de Guarda-Redes', preco: 600, icone: imgStickerTrofeuGuardaRedes, videoUrl: "" },
  { cromoNumero: 49, id: 149, nome: 'Vitória', preco: 600, icone: imgStickerVitoria, videoUrl: "" },
  { cromoNumero: 50, id: 150, nome: 'Vuvuzela', preco: 600, icone: imgStickerVuvuzela, videoUrl: "" }
];

export const obterListaCompleta50Cromos = () => {
  const listaCompleta = [];
  for (let i = 1; i <= 50; i++) {
    const cromoExistente = CROMOS_REAIS_INICIAIS.find(c => c.cromoNumero === i);
    if (cromoExistente) {
      listaCompleta.push(cromoExistente);
    } else {
      listaCompleta.push({
        cromoNumero: i,
        id: 1000 + i,
        nome: `Cromo ${i} em Breve`,
        preco: 500,
        icone: '/hero.png',
        video: null,
        emBreve: true
      });
    }
  }
  return listaCompleta;
};
